export class SignatureContent {
  fullnameText: string;
  initialsText: string;
  initialsSvg: string;
  initialsPng: string;
  fullnameSvg: string;
  fullnamePng: string;
}
